import { render, staticRenderFns } from "./CategoryNavBar.vue?vue&type=template&id=b4c0a962&"
import script from "./CategoryNavBar.vue?vue&type=script&lang=js&"
export * from "./CategoryNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports